import { useEffect } from 'react';

interface SEOHeadProps {
  title: string;
  description: string;
  keywords?: string;
  canonicalUrl?: string;
  ogType?: string;
  ogImage?: string;
  jsonLd?: object;
}

export default function SEOHead({ title, description, keywords, canonicalUrl, ogType = 'website', ogImage, jsonLd }: SEOHeadProps) {
  useEffect(() => {
    document.title = title;
    const metaDesc = document.querySelector('meta[name="description"]');
    if (metaDesc) metaDesc.setAttribute('content', description);
    const metaKw = document.querySelector('meta[name="keywords"]');
    if (metaKw) {
      if (keywords) metaKw.setAttribute('content', keywords);
    } else if (keywords) {
      const kw = document.createElement('meta');
      kw.name = 'keywords';
      kw.content = keywords;
      document.head.appendChild(kw);
    }
    let ogTitle = document.querySelector('meta[property="og:title"]');
    if (!ogTitle) { ogTitle = document.createElement('meta'); ogTitle.setAttribute('property', 'og:title'); document.head.appendChild(ogTitle); }
    ogTitle.setAttribute('content', title);
    let ogDesc = document.querySelector('meta[property="og:description"]');
    if (!ogDesc) { ogDesc = document.createElement('meta'); ogDesc.setAttribute('property', 'og:description'); document.head.appendChild(ogDesc); }
    ogDesc.setAttribute('content', description);
    let ogTypeEl = document.querySelector('meta[property="og:type"]');
    if (!ogTypeEl) { ogTypeEl = document.createElement('meta'); ogTypeEl.setAttribute('property', 'og:type'); document.head.appendChild(ogTypeEl); }
    ogTypeEl.setAttribute('content', ogType);
    if (canonicalUrl) {
      let canon = document.querySelector('link[rel="canonical"]');
      if (!canon) { canon = document.createElement('link'); canon.setAttribute('rel', 'canonical'); document.head.appendChild(canon); }
      canon.setAttribute('href', canonicalUrl);
    }
    if (ogImage) {
      let ogImg = document.querySelector('meta[property="og:image"]');
      if (!ogImg) { ogImg = document.createElement('meta'); ogImg.setAttribute('property', 'og:image'); document.head.appendChild(ogImg); }
      ogImg.setAttribute('content', ogImage);
    }
    if (jsonLd) {
      const scriptId = 'seo-jsonld';
      let script = document.getElementById(scriptId) as HTMLScriptElement | null;
      if (!script) {
        script = document.createElement('script');
        script.id = scriptId;
        script.type = 'application/ld+json';
        document.head.appendChild(script);
      }
      script.textContent = JSON.stringify(jsonLd);
    }
  }, [title, description, keywords, canonicalUrl, ogType, ogImage, jsonLd]);

  return null;
}